<div class="h-full w-full px-2">
  @for (parent of data; track $index) {
    <div class="mb-1">
      <app-node (onNodeClick)="nodeClick($event)" [data]="parent" [mobile]="mobile" [expanded]="expanded"></app-node>
    </div>
  }
</div>